const SCORE_COLOR = (s) =>
  s >= 70 ? "#00E5C0" : s >= 45 ? "#F59E0B" : "#E03030";

const SCORE_BG = (s) =>
  s >= 70 ? "#00E5C011" : s >= 45 ? "#F59E0B11" : "#E0303011";

function ScoreBadge({ score }) {
  const c = SCORE_COLOR(score);
  return (
    <span style={{
      background: SCORE_BG(score),
      color: c, border: `1px solid ${c}44`,
      borderRadius: 4, padding: "2px 8px", fontSize: 10, fontWeight: 700,
    }}>
      {score >= 70 ? "🟢" : score >= 45 ? "🟠" : "🔴"} {score}
    </span>
  );
}

function ChainBadge({ chain }) {
  const MAP = { BSC: "#F0B90B", SOLANA: "#9945FF", ETH: "#627EEA" };
  const c = MAP[chain] || "#555";
  return (
    <span style={{
      background: c + "22", color: c, border: `1px solid ${c}44`,
      borderRadius: 3, padding: "1px 6px", fontSize: 9, fontWeight: 700,
    }}>
      {chain}
    </span>
  );
}

function SimCell({ sims, window }) {
  const s = sims?.find(s => s.window === window);
  if (!s) return <span style={{ color: "#2A3040" }}>—</span>;
  const c = s.pnl_pct >= 0 ? "#00E5C0" : "#E03030";
  return (
    <span style={{ color: c, fontWeight: 600 }}>
      {s.pnl_pct >= 0 ? "+" : ""}{s.pnl_pct?.toFixed(1)}%
    </span>
  );
}

import { useState } from "react";
import { api } from "../api";

export default function ScannerView({ signals, onDetail }) {
  const [scanning, setScanning] = useState(false);

  const handleRefresh = async () => {
    setScanning(true);
    await api.triggerScan();
    setTimeout(() => setScanning(false), 3000);
  };

  const TH = { padding: "8px 12px", fontSize: 8, color: "#2A3040",
               letterSpacing: 2, textAlign: "left", borderBottom: "1px solid #1C2030",
               textTransform: "uppercase" };
  const TD = { padding: "10px 12px", borderBottom: "1px solid #111520" };

  if (!signals.length) {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
          <button onClick={handleRefresh} disabled={scanning} style={{
            background: scanning ? "#00E5C022" : "transparent",
            border: "1px solid #00E5C033", color: scanning ? "#00E5C0" : "#555E6E",
            borderRadius: 5, padding: "5px 12px", fontSize: 9,
            fontFamily: "'IBM Plex Mono',monospace", letterSpacing: 1,
            cursor: scanning ? "wait" : "pointer",
          }}>
            {scanning ? "SCAN EN COURS..." : "↻ SCAN"}
          </button>
        </div>
        <div style={{ textAlign: "center", padding: "80px 0", color: "#2A3040" }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>⚡</div>
          <div>Scan en cours... premiers résultats dans quelques instants</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <button onClick={handleRefresh} disabled={scanning} style={{
          background: scanning ? "#00E5C022" : "transparent",
          border: "1px solid #00E5C033", color: scanning ? "#00E5C0" : "#555E6E",
          borderRadius: 5, padding: "5px 12px", fontSize: 9,
          fontFamily: "'IBM Plex Mono',monospace", letterSpacing: 1,
          cursor: scanning ? "wait" : "pointer",
        }}>
          {scanning ? "SCAN EN COURS..." : "↻ SCAN"}
        </button>
      </div>
    <div style={{ background: "#0D1117", border: "1px solid #1C2030",
                  borderRadius: 10, overflow: "hidden", animation: "fadeIn .3s ease" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#0A0C10" }}>
            {["Token", "Chain", "Score sécu", "Signal", "P&L 1j", "P&L 7j", "P&L 30j", "Prix", ""].map(h => (
              <th key={h} style={TH}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {signals.map(sig => (
            <tr key={sig._id}
              style={{ cursor: "pointer", transition: "background .15s" }}
              onClick={() => onDetail(sig._id)}
              onMouseOver={e => e.currentTarget.style.background = "#111520"}
              onMouseOut={e => e.currentTarget.style.background = "transparent"}>
              <td style={TD}>
                <div style={{ fontWeight: 700, color: "#E0E4F0" }}>{sig.symbol}</div>
                <div style={{ fontSize: 9, color: "#2A3040", marginTop: 1 }}>{sig.name}</div>
              </td>
              <td style={TD}><ChainBadge chain={sig.chain} /></td>
              <td style={TD}><ScoreBadge score={sig.security_score} /></td>
              <td style={TD}>
                <span style={{
                  color: sig.trend_signal === "BUY" ? "#00E5C0" : "#2A3040",
                  fontWeight: sig.trend_signal === "BUY" ? 700 : 400,
                }}>
                  {sig.trend_signal === "BUY" ? "▲ BUY" : "— HOLD"}
                </span>
              </td>
              <td style={TD}><SimCell sims={sig.simulations} window="1j" /></td>
              <td style={TD}><SimCell sims={sig.simulations} window="7j" /></td>
              <td style={TD}><SimCell sims={sig.simulations} window="30j" /></td>
              <td style={TD}>
                <span style={{ fontFamily: "IBM Plex Mono", color: "#8892A4" }}>
                  ${sig.price_current?.toLocaleString(undefined, { maximumFractionDigits: 4 }) ?? "—"}
                </span>
              </td>
              <td style={TD}>
                <button style={{
                  background: "transparent", color: "#2A3040",
                  border: "1px solid #1C2030", borderRadius: 4,
                  padding: "3px 8px", fontSize: 9, cursor: "pointer",
                }}>
                  Détail →
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
}
